<template>
  <StageScaler>
    <SplashPageStage
      :key="fonts"
      data-testid="splash-page-stage"
      :title="theme_obj.title"
      :eventDate="eventDate"
      :eventLocation="theme_obj.location"
      :showEventDetails="true"
      :isWebinar="isWebinar"
      :is_title_visible="theme_obj.is_title_visible"
      :disableEventButton="theme_obj.disable_enter_event_button"
      :targets="targets"
      :trackOptions="trackOptions"
    />
  </StageScaler>
</template>

<script>
import { SplashPageStage } from '@goldcast/uicomponents-branding';
import { mapActions, mapGetters, mapState } from 'vuex';

import StageScaler from './StageScaler.vue';

import { startToEndDateString } from '@/utils/utils.js';

export default {
  name: 'SplashPageStagePreview',
  components: { SplashPageStage, StageScaler },
  mounted() {
    const { eventId } = this.$route.params;
    if (eventId) {
      this.fetchAgendaTracks({ eventId });
    }
  },
  computed: {
    ...mapGetters('branding', ['theme_obj']),
    ...mapGetters('studioEventList', {
      event: 'getCurrentEvent'
    }),
    ...mapState('studioAgenda', { agendaTracks: 'agendaTracks' }),
    isWebinar() {
      return this.event?.event_type === 'Webinar';
    },
    trackOptions() {
      if (this.agendaTracks?.length <= 1) {
        return [];
      }

      const trackOptions = this.agendaTracks?.map(track => {
        return {
          label: track.title,
          value: track.id
        };
      });

      trackOptions.unshift({
        label: 'All Tracks',
        value: 'All'
      });

      return trackOptions;
    },
    eventDate() {
      if (this.event?.start_time && this.event?.end_time) {
        return startToEndDateString(new Date(this.event?.start_time), new Date(this.event?.end_time));
      }
      return '';
    },
    targets() {
      const targets = this.$store.getters['branding/currentTargets'];
      // Force this getter to depend on the showAgendaSectionGetter so that
      // the holes get repainted even if targets have not changed but the page has scrolled
      const reverse = this.showAgendaSection;

      if (reverse) {
        return targets.reverse();
      }
      return targets;
    },
    fonts() {
      const {
        font_type,
        theme_font_src,
        theme_font_link,
        theme_font_name,
        splash_text_onimage_color,
        splash_font_type,
        splash_theme_font_src,
        splash_theme_font_link,
        splash_theme_font_name
      } = this.theme_obj;
      return [
        font_type,
        theme_font_src,
        theme_font_link,
        theme_font_name,
        splash_text_onimage_color,
        splash_font_type,
        splash_theme_font_src,
        splash_theme_font_link,
        splash_theme_font_name
      ]
        .filter(Boolean)
        .join(',');
    }
  },
  methods: {
    ...mapActions('studioAgenda', { fetchAgendaTracks: 'fetchAgendaTracks' })
  }
};
</script>
